export default __webpack_public_path__ + "static/media/multipleDevices.63f23189.svg";